import {FC, useCallback, useEffect, useRef, useState} from 'react';
import { useLocation } from "react-router-dom";
import { useWxWork } from '@cloud/wxwork-workbench';
import PageLayout from '@/layouts/page';
import List, {ActionType as ListActionType} from "@/components/List";
import Toast from '@/components/Toast';
import Button from '@/components/Button';
import {MomentsStatus, momentsStatusList, StatusAnalysis, defaultAnalysis, COMPONENTS} from './constants';
import {queryMomentsList, queryTaskStatus, queryMediaInfo, queryMomentsSummary, executeFinish, logMoment} from './service'
import styles from './index.less'

const MomentsTasksPage: FC<{}> = () => {
    const [status, setStatus] = useState<MomentsStatus>(momentsStatusList[0].key);
    const [analysis, setAnalysis] = useState<StatusAnalysis>(defaultAnalysis);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [isShowSendBtn, setIsShowSendBtn] = useState<boolean>(true);
    const listActionRef = useRef<ListActionType>();
    const signature = useWxWork();
    const { search } = useLocation();
    const taskId = new URLSearchParams(search).get('taskId');

    // 获取未发送/已发送任务个数
    useEffect(() => {
        queryMomentsSummary(signature).then(res => setAnalysis(res))
    },[signature]);

    // 从提醒链接进入 通过任务id获取任务状态 展示该任务状态板块
    useEffect(() => {
        if(taskId){
            queryTaskStatus({taskId, auth: signature}).then(res => setStatus(res));
        }
    },[taskId, signature]);

    useEffect(() => {
        if (listActionRef.current) {
            listActionRef.current.refresh();
        }
    }, [status]);

    const fetchList = useCallback(async () => {
        const res = await queryMomentsList({publishStatus: status, auth: signature});
        if(status === MomentsStatus.NO_SEND) {
            setIsShowSendBtn(true);
        } else {
            setIsShowSendBtn(false);
        }
        return {
            data: res,
            pagination:{
                current: 1,
                pageSize: res.length,
                total: res.length,
            }};
    }, [status, signature]);

    const sendMoments = async (taskId)=>{
        setIsLoading(true)
        const mediaInfo = await queryMediaInfo({ auth: signature, taskId });
        logMoment({ auth: signature, taskId, msg: 'invoke:shareToExternalMoments' })
        wx?.invoke(
            "shareToExternalMoments",
            mediaInfo,
            async function(res) {
                logMoment({ auth: signature, taskId, msg: `shareToExternalMoments: ${JSON.stringify(res)} >>>>>> err_msg: ${res.err_msg}` });
                console.log('error msg:', res);
                setIsLoading(false)
                if (res.err_msg === "shareToExternalMoments:permission denied") {
                    return Toast.error('请在企业微信手机端查看并执行发布');
                }
                if (res.err_msg === "shareToExternalMoments:cancel") {
                    return Toast.error('发布已取消');
                }
                if (res.err_msg !== "shareToExternalMoments:ok") {
                    return Toast.error('无法跳转到朋友圈，请手动打开');
                }
                await executeFinish({auth: signature, taskId});
                setStatus(MomentsStatus.SEND);
                queryMomentsSummary(signature).then(res => setAnalysis(res));
            })
    }

    const handleTabChange = (key: MomentsStatus) => {
        setStatus(key);
    }

    const handleContent = content => {
        return content.map((item, index) => {
            const View = COMPONENTS[item.type];
            return <View item={item} key={index}  />;
        });
    };

    const renderNotice = () => {
        // phone
        if (navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)) return;
        // PC
        return <div className={styles.notice}>请在企业微信手机端查看并执行发布</div>;
    }

    return <>
        {renderNotice()}
        <PageLayout
            tabs={momentsStatusList.map(({ key, title }) => ({key, title, count: analysis[key]}))}
            activeKey={status}
            onTabChange={handleTabChange}>
            <div className={styles.main}>
                <List
                    actionRef={r => listActionRef.current = r}
                    request={fetchList}
                    loadDataLength={99999}
                    scrollThreshold='0px'
                    rowKey='id'
                    renderItem={({id, sendTime, content}) => (
                        <div className={styles.momentsTask}>
                            <div className={styles.momentsInfo}>
                                <div className={styles.item}>
                                    <div className={styles.label}>任务类型：</div>
                                    <div className={styles.content}>发布企微个人朋友圈</div>
                                </div>
                                <div className={styles.item}>
                                    <div className={styles.label}>任务时间：</div>
                                    <div className={styles.content}>{sendTime}</div>
                                </div>
                                <div className={styles.item}>
                                    <div className={styles.label}>任务内容：</div>
                                    <div className={styles.content}>{handleContent(content)}</div>
                                </div>
                            </div>
                            {isShowSendBtn && <Button type="text" className={styles.sendBtn} onClick={() => sendMoments(id)} disabled={isLoading}>前往发布</Button>}
                        </div>
                    )}
                />
            </div>
        </PageLayout>
    </>
}

export default MomentsTasksPage;
